import React from 'react';
import Styles from './ToyotaFortuner.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import {cars} from './Data';
import Hero from '../HeroForm/Hero';

const ToyotaFortuner = () => {
  return (
    
     <div className={Styles.main_page}>
     <h2>Toyota Fortuner</h2>
     {/*Carousel*/}
     <div className={Styles.car_image}>
       <Carousel images={cars} />
     </div>
     <Hero selectedCar="Toyota Fortuner" /> 
   </div>
  );
}

export default ToyotaFortuner;
